import { useTranslation } from "react-i18next";
import { useState } from "react";
import Tabs from "./tabs";
import GeneralSettingsTab from "./tab/generalSetingsTab";
import AccountSettingsTab from "./tab/accountSettinsTab";
import NotificationsTab from "./tab/notificationsTab";

const Settings = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("general");

  return (
    <main>
      <h1 className="text-lg font-bold capitalize md:text-2xl text-primary">
        {t("settings")}
      </h1>

      <Tabs t={t} setTab={setTab} tab={tab} />
      <article className="mt-8">
        {tab === "general" && <GeneralSettingsTab t={t} />}
        {tab === "account" && <AccountSettingsTab t={t} />}
        {tab === "notifications" && <NotificationsTab t={t} />}
      </article>
    </main>
  );
};

export default Settings;
